export default __webpack_public_path__ + "static/media/6.daec3f08.jpg";